import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20panorama%20with%20dramatic%20lighting%2C%20silhouettes%20of%20athletes%20in%20motion%20across%20multiple%20sports%20disciplines%20including%20football%20and%20basketball%2C%20abstract%20geometric%20energy%20waves%20in%20warm%20red%20and%20gold%20tones%2C%20dark%20atmospheric%20background%20with%20spotlight%20effects%2C%20cinematic%20sports%20photography%20style%2C%20epic%20scale%2C%20professional%20composition&width=1800&height=900&seq=ky-hero-bg&orientation=landscape"
        alt="ky体育 - 官方体育竞技平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white tracking-tight leading-tight">
            极致竞技，<span className="text-accent-400">此刻点燃</span>
          </h1>
          <p className="mt-6 text-base md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
            ky体育汇聚全球顶级赛事，为您提供实时数据、深度资讯与沉浸式体育体验。足球、篮球、网球、电竞——所有热爱，一站尽享。
          </p>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/football"
              className="px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
            >
              查看热门赛事
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-full hover:bg-white/20 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm border border-white/30"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-8 text-white/60 text-xs">
          <span className="flex items-center gap-2"><i className="ri-live-line"></i> 实时数据</span>
          <span className="flex items-center gap-2"><i className="ri-global-line"></i> 全球赛事</span>
          <span className="flex items-center gap-2"><i className="ri-flashlight-line"></i> 毫秒级更新</span>
        </div>
      </div>
    </section>
  );
}